import type { ThemeAdapter } from '@cowbell/broker';

/**
 * The console's theme, read from Redux, as one of the two schemes the broker
 * library knows. Redux can hold whatever a settings action set, so anything
 * other than dark reads as light — the console's own default.
 */
export function toColorScheme(
  consoleTheme: unknown
): ThemeAdapter['colorScheme'] {
  if (consoleTheme === 'dark') {
    return 'dark';
  }
  return 'light';
}
